module.exports = "<span class=\"loader\"><p>{{ text }}</p><span></span><span></span><span></span><span></span></span>\n";